<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-flex class="paginator-flexbox">
    <v-row
      no-gutters
      justify="end"
    >
      <v-col
        class="paginator-wrapper"
        cols="auto"
      >
        <v-btn
          class="paginator-button"
          x-small
          dark
          fab
          :disabled="!isPrevPageEnabled"
          @click="$emit('page-change', 'backward')"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <span :class="`paginator-page current ${alternateStyle ? 'alternative' : ''}`">
          <v-text-field
            v-model="page"
            dark
            outlined
            dense
            type="number"
            :min="1"
            :hide-details="true"
            :max="numberOfPages"
            :style="pageField"
            @keyup.enter="onPageChange"
          />
        </span>
        <div
          v-if="!undeterminate"
          class="paginator-label paginator-page"
        >
          {{ $t(label) }}
        </div>
        <span
          v-if="!undeterminate"
          class="paginator-page"
        >
          {{ Math.max(1, numberOfPages) }}
        </span>
        <v-btn
          class="paginator-button"
          x-small
          dark
          fab
          :disabled="disableNextPage || !isNextPageEnabled || undeterminate"
          @click="$emit('page-change', 'forward')"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-flex>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { min, max } from 'lodash';

const label = 'common.navigation.of';

const props = defineProps({
  currentIndex: {
    type: Number,
    required: true
  },
  numberOfElements: {
    type: Number,
    required: true
  },
  elementsPerPage: {
    type: Number,
    required: true
  },
  undeterminate: Boolean,
  disableNextPage: Boolean,
  alternateStyle: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['go-to-page']);

const page = ref(1); // TODO: If Vue 3.4 or above, to be replaced by defineModels

const pageField = computed(() => `width: max(${page.value.toString().length + 3}ch, 45px)`);

const currentPage = computed(() => Math.floor(props.currentIndex! / props.elementsPerPage!) + 1);

const numberOfPages = computed(() => Math.ceil(props.numberOfElements! / props.elementsPerPage!));

const isNextPageEnabled = computed(() => currentPage.value < numberOfPages.value);

const isPrevPageEnabled = computed(() => currentPage.value > 1);

function onPageChange() {
  page.value = max([page.value, 1])!;
  page.value = min([page.value, numberOfPages.value])!;

  if (currentPage.value !== page.value && page.value > 0) {
    emit('go-to-page', page.value);
  }
}

watch(
  currentPage,
  () => { page.value = currentPage.value; },
  { immediate: true }
);

watch(
  numberOfPages,
  onPageChange,
  { immediate: true }
);

</script>
<style lang="scss" scoped>
@import './styles/paginator.scss';
</style>
